module.exports = __webpack_public_path__ + "media/images/3dView-d3a999353a85045d4f5bc65f2d400fc9.svg";